<template>
    <div class="basicData" v-wechat-title="$t('添加/编辑数据角色')">
        <Title :title="$t('添加/编辑数据角色')"/>
        <div class="form_box">
            <div class="common_title account_new">{{ $t('角色基本信息') }}</div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span class="has_must">{{ $t('角色名称') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.number="parameters.name" clearable></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn_box">
            <button type="button" class="back_btn" @click="$router.go(-1)">{{ $t('返回') }}</button>
            <button type="button" class="save_btn" @click="save" v-permissions="26020401" v-noClick>{{ $t('保存') }}</button>
        </div>
        <div class="tab_content">
            <span :class="{ active_span : isActive === 1 }" @click="isActive = 1">{{ $t('组织结构') }}</span>
            <span :class="{ active_span : isActive === 2 }" @click="isActive = 2">{{ $t('BU结构') }}</span>
        </div>
        <div class="tree_box" v-show="isActive === 1" v-if="treeList.length > 0">
            <el-tree
                    ref="tree"
                    :data="treeList"
                    show-checkbox
                    :props="defaultProps"
                    node-key="id"
                    @node-click="nodeClick"
                    @check="check"
                    :check-strictly="isTrue"
                    :check-on-click-node="true"
                    :expand-on-click-node="false"
            ></el-tree>
        </div>
        <div class="bu_box" v-show="isActive === 2" v-if="buList.length > 0">
            <el-checkbox-group v-model="checkedBuList" @change="handleCheckedChange">
                <el-checkbox v-for="item in buList" :label="item.id" :key="item.id">
                    <el-tooltip effect="dark" :content="item.name" placement="top-start">
                        <span>{{ item.name }}</span>
                    </el-tooltip>
                </el-checkbox>
            </el-checkbox-group>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                isActive: 1,
                parameters: {
                    id: '',
                    name: '',
                    orgIds: '',
                    buIds: ''
                },
                treeList: [],
                buList: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                checkedBuList: [],
                isTrue: false
            }
        },
        mounted () {
            this.initMounted()
        },
        methods: {
            initMounted () {
                this.getOrgList()
                this.getBuList()
                if (this.$route.query.id) {
                    setTimeout(this.read, 100)
                }
            },
            check (data) {
                let Node = this.$refs.tree.getNode(data.id)
                if (data.level === 2) {
                    // for (let item of this.$refs.tree.getCheckedKeys()) {
                    //     if (item && this.$refs.tree.getNode(item).parent.parent.checked === false) {
                    //         this.$refs.tree.getNode(item).parent.parent.checked = true
                    //         Node.parent.checked = Node.parent.indeterminate = false
                    //     }
                    // }
                    Node.parent.checked = Node.parent.indeterminate = false
                }
                if (data.level === 3) {
                    Node.parent.indeterminate = Node.parent.checked = false
                    Node.parent.parent.indeterminate = Node.parent.parent.checked = false
                }
                this.parameters.orgIds = this.$refs.tree.getHalfCheckedKeys().concat(this.$refs.tree.getCheckedKeys()).join(',')
            },
            nodeClick(data, Node) {
                if (data.level === 2) {
                    // for (let item of this.$refs.tree.getCheckedKeys()) {
                    //     if (item && this.$refs.tree.getNode(item).parent.parent.checked === false) {
                    //         this.$refs.tree.getNode(item).parent.parent.checked = true
                    //         Node.parent.checked = Node.parent.indeterminate = false
                    //     }
                    // }
                    Node.parent.checked = Node.parent.indeterminate = false
                }
                if (data.level === 3) {
                    Node.parent.indeterminate = Node.parent.checked = false
                    Node.parent.parent.indeterminate = Node.parent.parent.checked = false
                }
                this.parameters.orgIds = this.$refs.tree.getHalfCheckedKeys().concat(this.$refs.tree.getCheckedKeys()).join(',')
            },
            handleCheckedChange (val) {
                this.parameters.buIds = val.join(',')
            },
            save () {
                if (!this.parameters.name) {
                    this.$message.info(this.$t('请输入') + this.$t('角色名称'))
                    return false
                }
                if (!this.parameters.orgIds) {
                    this.$message.info(this.$t('请选择') + this.$t('组织结构'))
                    return false
                }
                if (!this.parameters.buIds) {
                    this.$message.info(this.$t('请选择') + this.$t('BU结构'))
                    return false
                }
                this.$store.dispatch(this.$route.query.id ? 'a:maintainDataRole/update' : 'a:maintainDataRole/create', this.parameters).then(
                    () => {
                        this.$message.success(this.$t('保存成功'));
                        this.$router.go(-1)
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            read () {
                this.$store.dispatch('a:maintainDataRole/read', {id: this.$route.query.id}).then(
                    res => {
                        this.parameters = res;
                        this.isTrue = true
                        this.$refs.tree.setCheckedKeys([])
                        setTimeout(() => {
                            for (let item of res.orgIds.split(',')) {
                                this.$refs.tree.setChecked(item, true, false)
                            }
                            for (let item of res.buIds.split(',')) {
                                this.checkedBuList.push(Number(item))
                            }
                            setTimeout(() => {
                                this.isTrue = false
                            }, 300)
                        }, 300)
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            getOrgList () {
                this.$store.dispatch('a:maintainDataRole/getOrgList').then(
                    res => {
                        this.treeList = res
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            getBuList () {
                this.$store.dispatch('a:maintainDataRole/getBuList').then(
                    res => {
                        this.buList = res
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            }
        }
    }
</script>

<style>
.bu_box .el-checkbox{
    margin-left: 30px;
}
</style>

<style lang="scss" scoped>
    .tab_content {
        height: 42px;
        line-height: 42px;
        padding: 0 75px;
        background: #EFF3F6 url("~img/common/account-role.png") no-repeat 44px;
        background-size: 26px;
        margin-bottom: 10px;
        span {
            display: inline-block;
            min-width: 90px;
            height: 30px;
            padding: 0 5px;
            background: #EFF3F6;
            border: 1px solid #5b5b5b;
            color: #5b5b5b;
            font-size: 12px;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            user-select: none;
            margin: 0 10px;
            border-radius: 2px;
            font-weight: bold;
        }
        .active_span {
            background: #5b5b5b;
            color: #FFFFFF;
        }
    }
    .tree_box, .bu_box {
        padding: 10px 40px;
    }
</style>
